<template>
  <MyModal ref="myModalRef" title="审核" width="800px" height="400px">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="审核结果">
        <el-radio-group v-model="auditResultCode">
          <el-radio :label="1">审核通过</el-radio>
          <el-radio :label="0">审核不通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审核说明">
        <el-input type="textarea" v-model="auditExplain" :rows="10"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button type="primary" @click="handleSubmit">提交</el-button>
      <el-button @click="handleDirectlyClose">取消</el-button>
    </template>
  </MyModal>
</template>

<script>
import {requestFeedBackAudit} from "@/api/unpaidWages/complaint/index.js";
import MyModal from "@/components/myComponents/MyModal/index.vue";

export default {
  name: 'AuditModal',
  components: {
    MyModal
  },
  data() {
    return {
      recordId: "",
      complaintId: "",
      auditResultCode: 1,
      auditExplain: '',
      form: {
        auditResultCode: 1,
        auditExplain: '',
      }
    }
  },
  methods: {
    handleOpen(id, cid) {
      this.recordId = id;
      this.complaintId = cid;
      if (this.$refs.myModalRef) {
        this.$refs.myModalRef.handleOpen();
      }
    },

    handleDirectlyClose() {
      if (this.$refs.myModalRef) {
        this.$refs.myModalRef.handleDirectlyClose();
      }
    },

    async handleSubmit() {
      try {
        await requestFeedBackAudit({
          auditResultCode: this.auditResultCode,
          auditResultName: ['审核不通过','审核通过'][this.auditResultCode],
          auditExplain: this.auditExplain,
          id: this.recordId,
          complaintId: this.complaintId,
        });
        if (this.$refs.myModalRef) {
          this.$refs.myModalRef.handleDirectlyClose();
        }
        // 父组件更新数据
        this.$emit("handleUpdateData");
      } catch(error) {
        console.log(error);
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
